import { DatePicker, DatePickerProps } from 'antd';
import dayjs, { Dayjs } from 'dayjs';

interface UtcDatePickerProps extends DatePickerProps {}

export const UtcDatePicker: React.FunctionComponent<UtcDatePickerProps> = ({
  onChange,
  ...restProps
}) => {
  const handleUniformOnChange = (
    input: Dayjs | Dayjs[] | null,
    dateString: string | string[] | null,
  ) => {
    const single = Array.isArray(input) ? input[0] : input;
    const formatted = single ? dayjs(single).format('YYYY-MM-DD') : null;
    const value = formatted ? new Date(formatted) : null;
    (onChange as any)?.(
      (value ? dayjs(value) : null) as Dayjs,
      value?.toDateString() || (dateString as string),
    );
  };

  return (
    <DatePicker
      value={dayjs()}
      {...restProps}
      onChange={handleUniformOnChange}
      picker="date"
      format={dayjs.Ls.nl.formats.L}
    />
  );
};
